import { DowngradeMutationErrorResponse, TRegistrationSubmit } from '@util/registration/BasicFormModel'
import { toBasicRegistrationData } from '@data/api/mappers/workflowData/toBasicRegistrationData'
import { RequestInfo, requester } from '@data/api/requester'
import { UseMutationOptions, UseMutationResult, useMutation } from '@tanstack/react-query'

type PostBasicRegistrationArgs = TRegistrationSubmit

export const postBasicRegistrationRequest = (data: PostBasicRegistrationArgs): RequestInfo<TBasicStepWorkflowData> => ({
    method: 'POST',
    url: '/registration/basic',
    body: data,
    responseMapper: toBasicRegistrationData,
    // `params` will pick up the query string from the URL and
    // forward the data to the backend.
    // it does NOT support the array syntax for querystrings
    // example: "?param[]=a&param[]=b" will not work as expected.
    params: Object.fromEntries(new URLSearchParams(window.location.search).entries()),
})

const mutationFn = (requestArgs: PostBasicRegistrationArgs) => requester(postBasicRegistrationRequest(requestArgs))

type Data = TBasicStepWorkflowData

type Options = UseMutationOptions<Data, ApiError<DowngradeMutationErrorResponse>, PostBasicRegistrationArgs>

export const useBasicRegistrationMutation = (
    options?: Options
): UseMutationResult<Data, ApiError<DowngradeMutationErrorResponse>, PostBasicRegistrationArgs> =>
    useMutation({
        ...options,
        mutationFn,
    })
